import LoginEntryBase from '#BASE/components/downLoad/loginEntryDownload';
import BottomBar from 'WX/views/Download/DownloadCenterBottomBar.vue';

export default {
    mixins: [LoginEntryBase],
    components: {
        BottomBar,
    },
    data: function () {
        return {
            btnStyleConf: {
                [true]: "btn cancel",
                [false]: "btn closed",
            },
            checkSettingComplete: true,
            InitLockTime: 3,
            isNotShowToday: false,
        };
    },
}